import React, { useEffect, useState } from 'react';

import { Divider, Grid, Typography } from '@mui/material';

import {
    Text,
    Button,
    Select,
    Switch,
    Tabs,
    Documents,
    Combo,
    Document,
    DataGridPro as DataGrid
} from 'core/components';

import * as enums from 'core/enums';
import * as icons from 'core/icons';
import List from '../../../../../../store/List';

import { statesEntity } from 'core/enums';
import { ENTITY_MARCA } from '../../../../../../store/entities/constants';
import DetailMarca from 'views/maestros/Marcas/Detalle';
import { DateTime } from 'luxon';
import * as helpers from '../../../../../../core/helpers';

const ComboContraetiquetas = List(Combo, 'options', 'lstcontraetiquetas');
const ComboTipoVino = List(Combo, 'options', 'lsttipovino');
const ComboEnvase = List(Combo, 'options', 'lstenvases');
const ComboMarca = List(Combo, 'options', 'lstmarcas');
const ComboImprenta = List(Combo, 'options', 'lstimprentas');

let timeBoxCodigo = 0;

const validaHasta = (values, row, fieldName) => {
    const cantidad = fieldName === 'cantidad' ? values[0].value : row.cantidad;
    const desde = fieldName === 'desde' ? values[0].value : row.desde;
    const hasta = Number(cantidad) + Number(desde);

    values.push({
        field: 'hasta',
        value: hasta.toFixed(0)
    });

    return values;
};
const cols = (name, row, index, editing, handleChange, values, tipo) => [
    {
        key: 'cantidad',
        title: 'Cantidad',
        align: 'left',
        //width: '8%',
        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='cantidad'
                variant='standard'
                margin='none'
                type='entero'
                value={row.cantidad}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values =>
                        handleChange(
                            validaHasta(values, row, 'cantidad'),
                            name,
                            index
                        ))
                }
            />
        )
    },
    values.tramite.tipo.baja
        ? {
              key: 'destruir',
              title: 'Destruir',
              align: 'center',
              //width: '15%',
              component: row && (
                  <Switch
                      value={row.destruir}
                      onChange={
                          handleChange &&
                          (values => handleChange(values, name, index))
                      }
                      name='destruir'
                      editing={values.tramite.numeracion ? false : editing}
                  />
              )
          }
        : undefined,
    {
        key: 'contraetiqueta',
        title: 'Contraetiqueta',
        align: 'left',
        width: '25%',
        component: row && (
            <ComboContraetiquetas
                fullWidth
                variant='standard'
                api='auxiliares/contraetiquetas/'
                name='contraetiqueta'
                nameKey='contraetiquetaId'
                Icon={icons.ContraetiquetasIcon}
                value={row.contraetiqueta}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option =>
                    values.tramite.numeracion
                        ? `${option.descripcion}-[${option.serie}]`
                        : `${option.descripcion}-[${option.serie}]-[${option.tipo}]-[${option.bobinado}]-[${option.rollo}]`
                }
                searchKeys={['descripcion']}
            />
        )
    },
    {
        key: 'desde',
        title: 'Desde',
        align: 'left',
        //width: '10%',
        component: row && (
            <Text
                fullWidth
                variant='standard'
                editing={editing}
                name='desde'
                margin='none'
                type='entero'
                value={row.desde}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values =>
                        handleChange(
                            validaHasta(values, row, 'desde'),
                            name,
                            index
                        ))
                }
            />
        )
    },
    {
        key: 'hasta',
        title: 'Hasta',
        align: 'left',
        //width: '10%',
        component: row && (
            <Text
                fullWidth
                variant='standard'
                editing={false}
                name='hasta'
                margin='none'
                type='entero'
                value={row.hasta}
                onFocus={event => event.target.select()}
                /*onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }*/
            />
        )
    },
    {
        key: 'envase',
        title: 'Envase',
        align: 'left',
        width: '12%',
        component: row && (
            <ComboEnvase
                required
                fullWidth
                variant='standard'
                api='auxiliares/envases/'
                name='envase'
                nameKey='envaseId'
                Icon={icons.PackageIcon}
                value={row.envase}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    },
    {
        key: 'tipoVino',
        title: 'Tipo Vino',
        align: 'left',
        width: '10%',
        component: row && (
            <ComboTipoVino
                fullWidth
                variant='standard'
                api='auxiliares/variedadesvino/'
                name='tipoVino'
                nameKey='tipoVinoId'
                Icon={icons.WineIcon}
                value={row.tipoVino}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    },
    {
        key: 'añada',
        title: 'Añada',
        align: 'left',
        //width: '5%',
        component: row && (
            <Text
                fullWidth
                variant='standard'
                editing={editing}
                name='añada'
                margin='none'
                type='0.4'
                value={row.añada}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    },
    {
        key: 'marca',
        title: 'Marca',
        align: 'left',
        width: '12%',
        component: row && (
            <ComboMarca
                fullWidth
                variant='standard'
                api={`marcasbodega/bodega/${values.tramite.explotacion.bodega.id}`}
                name='marca'
                nameKey='marcaId'
                Icon={icons.BrandsIcon}
                value={row.marca}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => `${option.nombre}`}
                relacionado={{
                    api: 'marcasbodega/',
                    type: ENTITY_MARCA,
                    Detail: DetailMarca,
                    resume: ['nombre'],
                    readOnly: false
                }}
                searchKeys={['nombre']}
            />
        )
    },
    values.tramite.numeracion
        ? {
              key: 'imprenta',
              title: 'Imprenta',
              align: 'left',
              width: '12%',
              component: row && (
                  <ComboImprenta
                      fullWidth
                      variant='standard'
                      api={`imprentas`}
                      name='imprenta'
                      nameKey='imprentaId'
                      Icon={icons.ImprentaIcon}
                      value={row.imprenta}
                      onChange={
                          handleChange &&
                          (values => handleChange(values, name, index))
                      }
                      editing={editing}
                      propertyValue='id'
                      getOptionLabel={option => `${option.descripcion}`}
                      /*relacionado={{
                          api: 'marcasbodega/',
                          type: ENTITY_MARCA,
                          Detail: DetailMarca,
                          resume: ['nombre'],
                          readOnly: false
                      }}*/
                      searchKeys={['descripcion']}
                  />
              )
          }
        : undefined
];

const Contraetiquetas = props => {
    const {
        values,
        editing,
        handleChange,
        handleError,
        refresh,
        execAction,
        reload
    } = props;

    const [cantidadTotal, setCantidadTotal] = useState(0);

    useEffect(() => {
        calculaTotales();
    }, [JSON.stringify(values.detalleAlmacenamiento)]);

    const calculaTotales = () => {
        let newCantidadTotal = 0;

        if (values && values.detalleAlmacenamiento) {
            values.detalleAlmacenamiento.forEach(detalle => {
                newCantidadTotal += Number(detalle.cantidad);
            });
        }

        setCantidadTotal(newCantidadTotal);
    };

    const actualizaCodigo = () => {
        if (editing) {
            const action = () => {
                const accion = {
                    api: 'tramites/emcs',
                    metodo: 'post',
                    data: {
                        fields: ['emcs'],
                        values: { ...values }
                    }
                };
                execAction(accion, [reload]);
            };

            timeBoxCodigo > 0 && clearTimeout(timeBoxCodigo);
            timeBoxCodigo = setTimeout(action, 250);
        }
    };

    return (
        <form autoComplete='off' noValidate>
            <Grid container spacing={2}>
                <Grid item xs>
                    <Grid container direction='column' spacing={2}>
                        <Grid item xs>
                            <Grid
                                container
                                justifyContent={'space-around'}
                                alignItems={'center'}
                            >
                                {/*<Grid item>
                                    <Switch
                                        value={values.tramite.numeracion}
                                        onChange={handleChange}
                                        name='numeracion'
                                        label='Numeracion'
                                        editing={false}
                                    />
                                </Grid>*/}
                                <Grid item xs>
                                    <Grid
                                        sx={{
                                            marginTop: '10px',
                                            marginBottom: '10px',
                                            backgroundColor: 'lightgray',
                                            height: 25,
                                            borderRadius: 1
                                        }}
                                        container
                                        justifyContent={'space-around'}
                                        alignItems={'center'}
                                    >
                                        <Grid item>
                                            <Typography variant={'h5'}>
                                                {'Detalles Contraetiquetas'}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant={'h5'}>
                                                {`Cantidad Total: ${helpers.getValueFormatted('d.2', cantidadTotal)}`}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs>
                            <DataGrid
                                name='detalleContraetiquetas'
                                editing={editing}
                                rows={
                                    values.detalleContraetiquetas
                                        ? values.detalleContraetiquetas
                                        : []
                                }
                                cols={(name, row, index) =>
                                    cols(
                                        name,
                                        row,
                                        index,
                                        editing,
                                        handleChange,
                                        values
                                    )
                                }
                                onAdd={name => {
                                    handleChange(
                                        {
                                            destruir:
                                                values.tramite.tipo.baja &&
                                                values.tramite.numeracion
                                                    ? true
                                                    : false
                                        },
                                        name
                                    );
                                }}
                                onDelete={(name, index) =>
                                    handleChange(
                                        undefined,
                                        name,
                                        (index + 1) * -1
                                    )
                                }
                                minHeight={350}
                                maxHeight={350}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
};

export default Contraetiquetas;
